import { myFetch, HttpMethod } from './baseService';

// ==================== INTERFACES ====================

export interface TurnoZonaComun {
  codigo: number;
  "zona comun horario por dia codigo": number;
  "inicio turno": string;
  "fin turno": string;
  "estatus codigo": string;
  
  // Legacy/Fallback keys (optional)
  ztr_codigo?: number;
  ztr_zona_comun_horario_por_dia?: number;
  ztr_zona_comun?: string;
  ztr_inicio_turno?: string;
  ztr_fin_turno?: string;
  ztr_estatus?: string;
  [key: string]: any;
}

export interface ObtenerTurnosZonaComunRequest {
  codigo: string;
  "zona comun horario por dia codigo": number;
  "estatus codigo": string;
}

export interface InsertarTurnoZonaComunRequest {
  "zona comun horario por dia codigo": number;
  "inicio turno": string;
  "fin turno": string;
}

export interface ModificarTurnoZonaComunRequest {
  codigo: number;
  "zona comun horario por dia codigo": number;
  "inicio turno": string;
  "fin turno": string;
}

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

// ==================== FUNCIONES API ====================

/**
 * Obtener todos los turnos por día de zona común
 */
export const obtenerTurnosZonaComun = async (
  payload: ObtenerTurnosZonaComunRequest
): Promise<ApiEnvelope<TurnoZonaComun[]>> => {
  const envelope = await myFetch<ApiEnvelope<TurnoZonaComun[]>>(
    'zona_comun_turnos_para_reserva/ObtenerTodos',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

/**
 * Insertar un nuevo turno por día de zona común
 */
export const insertarTurnoZonaComun = async (
  payload: InsertarTurnoZonaComunRequest
): Promise<ApiEnvelope<TurnoZonaComun[]>> => {
  const envelope = await myFetch<ApiEnvelope<TurnoZonaComun[]>>(
    'zona_comun_turnos_para_reserva/Insertar',
    HttpMethod.POST,
    payload
  );
  return envelope;
};


/**
 * Modificar un turno por día de zona común
 */
export const modificarTurnoZonaComun = async (
  payload: ModificarTurnoZonaComunRequest
): Promise<ApiEnvelope<TurnoZonaComun[]>> => {
  const envelope = await myFetch<ApiEnvelope<TurnoZonaComun[]>>(
    'zona_comun_turnos_para_reserva/Modificar',
    HttpMethod.POST,
    payload
  );
  return envelope;
};
